define(["require", "exports", "jquery", "./context", "./productImages"], function (require, exports, $, context_1, productImages_1) {
    "use strict";
    exports.__esModule = true;
    function addPicturesAsAsset($link, pictures) {
        var isPhone = context_1["default"].isMobile();
        var selector = isPhone ? 'div' : '.asset-box';
        var sizeKey = isPhone ? 'size_630' : 'size_125';
        var $box = $link.closest(selector);
        var $prev = $box.prev(selector);
        var $asset = $($prev.html());
        if (!isPhone) {
            $asset.attr({
                'href': pictures['size_full'],
                'rel': $asset.attr('rel').replace(/smallImage:'[^']+'/, 'smallImage:\'' + pictures['size_630'] + '\'')
            });
        }
        $asset.find('img').addBack().filter('img').attr({
            'src': pictures[sizeKey],
            'title': 'uploaded',
            'alt': 'uploaded',
            'data-details-url': pictures['size_630'],
            'data-asset_id': '',
            'data-picture_id': pictures['id'],
            'data-asset_link': ''
        });
        var $text = isPhone ? $asset.filter('label') : $asset.find('.asset-name');
        $text.text('uploaded');
        var $newbox = isPhone ? $('<div></div>') : $('<div class="asset-box"></div>');
        $newbox.append($asset).insertBefore($box);
        if (!isPhone) {
            $asset.filter('.cloud-zoom-gallery').on('click', toggleAssetSelection).CloudZoom().click();
        }
        else {
            var $paging = $link.closest('.photoshow').find('.paging');
            $paging.data('total', parseInt($paging.data('total')) + 1);
        }
    }
    exports.addPicturesAsAsset = addPicturesAsAsset;
    function onWindowStyleChanged(e, allWindowMeasurements) {
        var $selected = $(e.currentTarget);
        var $spec = $selected.closest('.window-spec');
        if (!$spec.length)
            return;
        var $container = $('.window-size-spec > .sub-section .overview');
        var measurements = allWindowMeasurements.rectWindowMeasurements;
        $.each(allWindowMeasurements, function (key, val) { if ($selected.hasClass(key)) {
            measurements = val;
        } });
        $container.empty();
        Customization.renderWindowMeasurements($container, measurements);
    }
    exports.onWindowStyleChanged = onWindowStyleChanged;
    function toggleRelatedSection($section, enable) {
        $section.find('input').prop('disabled', !enable);
        if ($section.hasClass('expanded') && !enable) {
            $section.toggleClass('expanded collapsed');
        }
    }
    function toggleAssetSelection(e) {
        e.preventDefault();
        e.stopPropagation();
        onWindowStyleChanged(e, allWindowMeasurements);
        var anchor = $(e.currentTarget);
        var picker = anchor.closest('.asset-picker');
        picker.find('a.asset').removeClass('selected');
        anchor.addClass('selected');
        var img = anchor.find('img');
        var tag = picker.data('category_id');
        var thumbs = $('.customize.picturethumbs');
        var index = 0;
        var existing = thumbs.find('div.a-left').filter(function (i, div) {
            var result = $(div).data('tag') == tag;
            if (result) {
                index = i;
            }
            return result;
        });
        if (img.length) {
            var images = {
                full: img.data('full-url'),
                detail: img.data('details-url'),
                thumb: img.attr('src')
            };
            if (existing.length) {
                productImages_1.replaceThumbImage(existing, images);
                existing.show();
            }
            else {
                productImages_1.insertThumbImage(thumbs, images, true).data('tag', picker.data('category_id'));
                index = thumbs.find('div.a-left').length - 1;
            }
            $('#zoom1').add(thumbs.find('a.img-zoom')).slimbox({
                loop: true,
                nextKeys: [39, 78, 32]
            }, null, function (el) { return !$(el).attr('id'); });
        }
        else {
            existing.hide();
        }
        $('#fabric-zoom-' + picker.data('category_id')).attr('src', img.data('details-url'));
        var $spec = picker.closest('.sub-section').parent();
        var $section = null;
        var enabled = img.length > 0;
        if ($spec.hasClass('style-spec')) {
            $section = $('.valance-size-spec .sub-section');
        }
        else if ($spec.hasClass('panel-spec')) {
            $section = $('.panel-size-spec .sub-section');
        }
        if ($section) {
            $section.toggleClass('not-applicable', !enabled);
            toggleRelatedSection($section, enabled);
        }
        $('.product-thumbs').trigger('rezoom', index);
    }
    exports.toggleAssetSelection = toggleAssetSelection;
    var assetUploadCallback = function (pictures) {
    };
    var uploadAsset = null;
    function onAssetUploaded(pictures) {
        assetUploadCallback(pictures);
        $('#uploadAssetFrame').dialog("close");
        $('#uploadAssetFrame').remove();
    }
    ;
    function uploadAssetForCustomer(customerId) {
        var $iframe = $('<iframe id="uploadAssetFrame"></iframe>').attr('src', "/CurtainDesign/upload?callback=onAssetUploaded&forCustomer=" + customerId);
        $iframe.appendTo($('.master-wrapper-content'));
        $iframe.dialog({
            modal: true,
            width: 480,
            height: 320
        });
    }
    function bindAssetUpload(customerId) {
        $('.upload-asset').click(function (e) {
            e.preventDefault();
            var $link = $(e.currentTarget);
            assetUploadCallback = function (pictures) {
                addPicturesAsAsset($link, pictures);
            };
            uploadAsset = function () {
                uploadAssetForCustomer(customerId);
            };
            context_1["default"].ensureUserRegistered(uploadAsset, 'uploadAsset');
        });
    }
    exports.bindAssetUpload = bindAssetUpload;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/customization.js
// module id = 72
// module chunks = 0